<template>
  <v-row>
    <v-col 
      v-if="!loading"
      cols="12" 
      class="pa-4 ma-2 mb-8 mt-8">
      <cardFeaturedSponsors :types_sponsors="types_sponsors" />
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'typeFeaturedSponsorsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  import cardFeaturedSponsors from '@/components/card/cardFeaturedSponsors'

  export default {
    name: 'showAllFeaturedSponsorsEdition',
    components:{
      cardFeaturedSponsors
    },

    data: () => ({
      loading:true,


      types_sponsors:[],

      edition_id: null,
      types_sponsor_id: null,
      sponsor_id: null,
    }),

    methods:{
      async getAllSponsorsEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/types-featured-sponsors/all-sponsors').then(response =>{
          this.types_sponsors = response.data.data.types_sponsors
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.getAllSponsorsEdition()
    },
  }
</script>
